import styled from 'styled-components'
import { media } from '../../../breakpoints'

export const Wrapper = styled.div`
  width: 100%;
  height: 169px;
  background-color: #FFFFFF;
  z-index: 100;
  color: #50637F;
  padding: 41px 61px 0 61px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;

  ${media.desktop`
    padding: 30px 24px 0 24px;
  `}

  ${media.tablet`
    height: auto;
    min-height: 0;
    padding: 12px 16px 0 16px;
    gap: 10px;
  `}

  .tabs-counter{
    display: flex;
    justify-content: space-between;

    ${media.tablet`
      flex-direction: column;
      gap: 10px;
    `}
  }

`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .title-profile {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo-title-date {
      display: flex;
      align-items: center;

      .title {
        margin-left: 7px;
        width: 250px;
        height: 52px;
        font-size: 22px;
        line-height: 52px;
        text-align: center;
        letter-spacing: 0.305556px;
        
        position: relative;

        ${media.tablet`
          width: auto;
          height: auto;
          font-size: 17px;
          line-height: 22px;
          text-align: left;
          padding-bottom: 16px;
        `}

        .date {
          position: absolute;
          left: 12.5px;
          top: 60px;
          font-size: 14px;
          line-height: 0;
          letter-spacing: 0.194444px;

          ${media.tablet`
            left: 0;
            top: auto;
            bottom: 2px;
            font-size: 12px;
          `}
        }
      }
  }
  
    .profile{
      display: flex;
      align-items: center;
      
      .name{
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.685714px;
        margin-right: 10px;

        ${media.tablet`
          display: none;
        `}
      }

      .image{
        position: relative;
        .online{
          width: 17px;
          height: 17px;
          border-radius: 50%;
          position: absolute;
          top: 0;
          right: -5px;
          background-color: #4CC186;
          border: 2px solid white;
          

        }
        .picture-container{
          width: 50px;
          height: 50px;
          .profile-image{
            width:100%;
            height:100%;
            object-fit: cover;
            overflow: hidden;
            border-radius: 50%;
            
        }
        }
        
      }

      
      
      .menu-toggle {
        width: 23px;
        height: 23px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-left: 20px;
        
        :hover{
          cursor: pointer;
        }
        
        .circle{
          width: 5.75px;
          height: 5.75px;
          border-radius: 50%;
          background: #405573;
        
        }
      }
    }
  }
`

export const Dropdown = styled.div`
  position: absolute;
  width: 190px;
  height: 40px;
  bottom: 24px;
  right: 61px;
  border-radius: 8px;
  border: 1px solid #E8E8E8;
  display: ${props => props.opened ? 'flex' : 'none'};
  font-size: 14px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 8px 0px rgba(62, 85, 115, 0.24);
  color: #405573;
  font-family: 'Robot Regular', sans-serif;
  background-color: #FFFFFF;
  z-index: 200;
  
  :hover{
    cursor: pointer;
  }

  ${media.tablet`
    bottom: auto;
    top: 60px;
    right: 16px;
  `}
`

export const Tabs = styled.div`
  margin-left: 80px;
  height: 27px;
  display: inline-flex;
  gap: 30px;
  
  .tab{
    font-size: 14px;
    color: inherit;
    text-decoration: none;
  }
  
  .tab-selected{
    color: #F9C36C;
    border-bottom: 2px solid #F9C36C;
  }

  ${media.desktop`
    margin-left: 0;
    gap: 20px;
    flex-wrap: wrap;
    height: auto;
  `}

  ${media.tablet`
    display: ${props => props.opened ? 'flex' : 'none'};
    flex-direction: column;
    margin-left: 0;
    height: auto;
    gap: 0;

    .tab{
      padding: 12px 4px;
      border-bottom: 1px solid #F0F0F0;
      width: 100%;
    }

    .tab-selected{
      border-bottom: 1px solid #F0F0F0;
      border-left: 3px solid #F9C36C;
      padding-left: 10px;
    }
  `}
`

export const Hamburger = styled.button`
  display: none;
  background: none;
  border: none;
  padding: 6px;
  margin-right: 12px;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 30px;
  width: 32px;

  .bar {
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background-color: #405573;
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  ${props => props.opened && `
    .bar:nth-child(1) {
      transform: translateY(8px) rotate(45deg);
    }
    .bar:nth-child(2) {
      opacity: 0;
    }
    .bar:nth-child(3) {
      transform: translateY(-8px) rotate(-45deg);
    }
  `}

  ${media.tablet`
    display: flex;
  `}
`
